import { reducers } from 'redux/core'


const resetDate = (type) => reducers.lscSchedules.filters.resetDate(type)

const clear = (type) => reducers.lscSchedules.filters.clear(type)

const setDate = ({ type, date }) => {
  reducers.lscSchedules.filters.setDate({
    type,
    date,
  })
}

const setFilter = ({ type, filterType, data }) => {
  reducers.lscSchedules.filters.setFilter({
    type,
    filterType,
    data,
  })
}

const setFilterMultiple = ({ type, filterType, data }) => {
  reducers.lscSchedules.filters.setFilterMultiple({
    type,
    filterType,
    data,
  })
}


export default {
  clear,
  resetDate,
  setDate,
  setFilter,
  setFilterMultiple,
}
